module.exports = __webpack_public_path__ + "static/img/anchorage_logo.3db6fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anchorage_logo.png
// module id = 65
// module chunks = 1